module.exports = __webpack_public_path__ + "img/google-play-badge.8553ada1.png";